import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Offers from "@/pages/Offers";
import OfferDetail from "@/pages/OfferDetail";
import Visa from "@/pages/Visa";
import FlightQuote from "@/pages/FlightQuote";
import Login from "@/pages/Login";
import Contact from "@/pages/Contact";
import ClientDashboard from "@/pages/client/ClientDashboard";
import VisaFileDetail from "@/pages/client/VisaFileDetail";
import BookingPayment from "@/pages/client/BookingPayment";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/offer/:id" element={<OfferDetail />} />
            <Route path="/visa" element={<Visa />} />
            <Route path="/flight-quote" element={<FlightQuote />} />
            <Route path="/login" element={<Login />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/client" element={<ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>} />
            <Route path="/client/visa/:id" element={<ProtectedRoute role="client"><VisaFileDetail /></ProtectedRoute>} />
            <Route path="/client/payment/:bookingId" element={<ProtectedRoute role="client"><BookingPayment /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
